import { render } from "./Candidatures.vue?vue&type=template&id=85ca501a&scoped=true"
import script from "./Candidatures.vue?vue&type=script&lang=js"
export * from "./Candidatures.vue?vue&type=script&lang=js"

import "./Candidatures.vue?vue&type=style&index=0&id=85ca501a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85ca501a"]])

export default __exports__